import './asignar.css';
import { useState, useEffect } from "react";
import axios from 'axios';
import regr from '../Componentes/regr.png';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { registerLocale } from 'react-datepicker';
import es from "date-fns/locale/es";
import toast, { Toaster } from 'react-hot-toast';

registerLocale("es", es);
function Asignar({us, diISO,di,ho,arrf5 ,arrf7 , arrf11, onClose, resinformacion, otherinfo}) {//,nom,diISO,di,ho,tip,arrf5,arrf7
const [uso, setUso] = useState('');
const [diaISO, setDiaISO] = useState('');
const [dia, setdia] = useState('');
const [hora, sethora] = useState('');
const [arre5, setarre5] = useState([]);
const [arre7, setarre7] = useState([]);
const [arre11, setarre11] = useState([]);
const [asignado, setasignado] = useState('')
const hoy = new Date();
const [siete,setSiete] = useState(new Date());
const [datestring, setDatestring] = useState('');
const [horastring, setHoraString] = useState('');
const [horastringfin, setHoraStringfin] = useState('');
const [horarios, setHorarios] = useState([]);
const [radiobuttonnew, setRadiobuttonnew] = useState('');
const [ResInfo, setResInfo] = useState();
const [otrainfo, setOtherinfo] = useState();

axios.defaults.withCredentials = true;

const [errors, setErrors] = useState({
  NombreCliente: false,
  TelefonoCliente: false,
  Descripcion: false,
  asignado: false
});

const notify = () => toast.success('Edicion completada.', {position: 'top-center'});
const notifyerr = () => toast.error('Espacio no disponible.', {position: 'top-center'});

useEffect(()=>{
    setUso(us);
    setarre7(arrf7);
    setasignado(resinformacion?.id_cancha);
    setDiaISO(diISO);
    setdia(di);
    sethora(ho);
    setarre5(arrf5);
    setarre11(arrf11);
    sietedias();
    setResInfo(resinformacion);
    setOtherinfo(otherinfo);
    getHorariosEdit();
    
},[us]);

function getHorariosEdit(){
    axios.get(`${process.env.REACT_APP_HTTPS}/api/establecimientos/horarios`)
        .then((response) => {
          setHorarios(response.data);
        })
        .catch((error) => {
          console.error('Error al obtener los Horarios:', error);
          toast.error('Error al obtener horarios', {position: 'top-center'})
        });
  };

const [manejoHoras, setManejoHoras] = useState({apertura:'', cierre:''});
const diaFormateadoISO = (isoString) => {
  const [year, month, day] = isoString.split('-');
  const localDate = new Date(year, month - 1, day); // Parse as LOCAL time
  return localDate.toLocaleDateString('es-GT', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
  });
};

useEffect(() => {
      if (horarios.length > 0) {
        const holad = diaFormateadoISO(datestring.toISOString().split('T')[0]);
        const dia2 = holad.split(',')[0];
        horarios.forEach((user) =>{
          switch (dia2) {
            case 'lunes':
              const a0 = Number(String(user.LunesApertura).substr(0,2));
              const b0 = Number(String(user.LunesCierre).substr(0,2));
              setManejoHoras({apertura: a0, cierre: b0});
            break;
            case 'martes':
              const a1 = Number(String(user.MartesApertura).substr(0,2));
              const b1 = Number(String(user.MartesCierre).substr(0,2));
              setManejoHoras({apertura: a1, cierre: b1});
            break;
            case 'miércoles':
              const a2 = Number(String(user.MiercolesApertura).substr(0,2));
              const b2 = Number(String(user.MiercolesCierre).substr(0,2));
              setManejoHoras({apertura: a2, cierre: b2});
            break;
            case 'jueves':
              const a3 = Number(String(user.JuevesApertura).substr(0,2));
              const b3 = Number(String(user.JuevesCierre).substr(0,2));
              setManejoHoras({apertura: a3, cierre: b3});
            break;
            case 'viernes':
              const a4 = Number(String(user.ViernesApertura).substr(0,2));
              const b4 = Number(String(user.ViernesCierre).substr(0,2));
              setManejoHoras({apertura: a4, cierre: b4});
            break;
            case 'sábado':
              const a5 = Number(String(user.SabadoApertura).substr(0,2));
              const b5 = Number(String(user.SabadoCierre).substr(0,2));
              setManejoHoras({apertura: a5, cierre: b5});
            break;
            case 'domingo':
              const a6 = Number(String(user.DomingoApertura).substr(0,2));
              const b6 = Number(String(user.DomingoCierre).substr(0,2));
              setManejoHoras({apertura: a6, cierre: b6});
            break;
            default:
              break;
          }
        });
      }
    }, [horarios, datestring]);

useEffect(()=>{
    if (diaISO.length > 0) {
        const [year, month, day] = diaISO.split("-").map(Number); 
        const diaSeleccionado = new Date(year, month - 1, day);
        setDatestring(diaSeleccionado);
        const [hours, minutes, seconds] = [hora, 0, 0];
        const horaSeleccionada = new Date(year, month - 1, day);
        horaSeleccionada.setHours(Number(hours), minutes, seconds);
        setHoraString(horaSeleccionada);
        setHoraStringfin('')
    }
},[diaISO, hora, us])

const cerrarpestana = () => {
  terminarboton();
}
const Registrar = (e) =>{
    setasignado(e.target.value);
    if (e.target.value.trim() !== '') {
      setErrors({...errors, [e.target.name]: false});
  }
};

const [cliente, setCliente] = useState({
  NombreCliente:'',
  CorreoCliente:'',
  TelefonoCliente:'',
  idestablecimiento: '',
  Tipo:'',
  Medio:'Manual',
  Estado:'Aprobada',
  Descripcion: ''
});
const RegistrarInput = (e) =>{
  e.persist();
  setCliente({...cliente, [e.target.name]: e.target.value});
  if (e.target.value.trim() !== '') {
      setErrors({...errors, [e.target.name]: false});
  }
};

const RegistrarInput2 = (e) =>{
  e.persist();
  setCliente({...cliente, [e.target.name]: e.target.value});
};

const sietedias = () => {
    const max = new Date();
    max.setDate(hoy.getDate() + 364);
    setSiete(max);
  };

const clickasignar = () =>{
  const setearcancha = {...ResInfo, cancha_asignada:asignado };
  let hasErrors = false;
  let newErrors = {...errors};
    if (String(asignado) === 'undefined') {
        newErrors[asignado] = true;
        hasErrors = true;
    }
  setErrors(newErrors);
  if (hasErrors) {
      toast.error('Por favor, completa todos los campos.');
      return;
  }
  const result = Object.values(otrainfo).find(item => item.id === asignado);
    axios.post(`${process.env.REACT_APP_HTTPS}/api/reserva/set`, {setearcancha, otrainfo: result})
    .then(response => {
        console.log('Datos asignados exitosamente:', response.data);
        notify();
        terminarboton();
        return;//setDatosIng('ingresados')
      })
      .catch(error => {
        console.error('Error al guardar los datos:', error);
        notifyerr();
        return ; //setDatosIng('error')
      });
}

const clickcambfecha = () =>{
  setUso('editar');
  setasignado('');
}
const clickespecial = () =>{
  setUso('especial');
  setRadiobuttonnew('')
  setasignado('');
}
const terminarboton = () =>{
  setUso('');
  setasignado('');
  onClose();
  setRadiobuttonnew('');
  setErrors(false);
  setCliente({
    NombreCliente:'',
    CorreoCliente:'',
    TelefonoCliente:'',
    idestablecimiento: '',
    Tipo:'',
    Medio:'Manual',
    Estado:'Aprobada',
    Descripcion: ''
  });
}

async function clickeditar() {
  const setearcancha = await convertirdatoseditar();
  if (isNaN(manejoHoras.apertura)) {
    toast.error('La fecha seleccionada no esta disponible.');
    return;
  }
  let hasErrors = false;
  let newErrors = {...errors};
  Object.keys(setearcancha).forEach((key) => {
    if (key === 'correo' || key === 'Descripcion') {
      return
    }
      if (String(setearcancha[key]).trim() === '') {
          newErrors[key] = true;
          hasErrors = true;
      }
  });
  setErrors(newErrors);
  if (hasErrors) {
      toast.error('Por favor, completa todos los campos.');
      return;
  }
  const result = (jack) => {
    console.log(jack);
    
    if (jack === 5){
      const papi = arre5.find(item => item.id === String(asignado));
      return papi;
    }
    else if (jack === 7){
      const papi = arre7.find(item => item.id === String(asignado));
      return papi;
    }
    else if (jack === 11){
      const papi = arre11.find(item => item.id === String(asignado));
      return papi;
    }
  }
  const jason = result(setearcancha.tipo_cancha);
  console.log(setearcancha);
  

  axios.post(`${process.env.REACT_APP_HTTPS}/api/reserva/edit`, {setearcancha, otrainfo: jason})
  .then(response => {
      console.log('Datos guardados exitosamente:', response.data);
      notify();
      terminarboton();
      return;//setDatosIng('ingresados')
    })
    .catch(error => {
      console.error('Error al guardar los datos:', error);
      notifyerr();
      return ; //setDatosIng('error')
    });
}


async function clcikenviar() {
  const clientee = await convertirdatos();
  if (isNaN(manejoHoras.apertura)) {
    toast.error('La fecha seleccionada no esta disponible.');
    return;
  }
  let hasErrors = false;
  let newErrors = {...errors};
  Object.keys(clientee).forEach((key) => {
    if (key === 'CorreoCliente' || key === 'Descripcion') {
      return
    }
      if (String(clientee[key]).trim() === '') {
          newErrors[key] = true;
          hasErrors = true;
      }
  });
  setErrors(newErrors);
  if (hasErrors) {
      toast.error('Por favor, completa todos los campos.');
      return;
  }
  const datcancha = (tipoca) => {
    if (tipoca === "5") {
      const resultipoca = arre5.find(datos => datos.id === asignado);
      return resultipoca;
    }
    else if (tipoca === "7"){
      const resultipoca = arre7.find(datos => datos.id === asignado);
      return resultipoca;
    }
    else if (tipoca === "11"){
      const resultipoca = arre11.find(datos => datos.id === asignado);
      return resultipoca;
    }
  }
  const canchasel = datcancha(clientee.Tipo);

  axios.post(`${process.env.REACT_APP_HTTPS}/api/reserva/save`, {clientee, canchasel})
    .then(response => {
        console.log('Datos guardados exitosamente:', response.data);
        notify();
        terminarboton();
        return;//setDatosIng('ingresados')
      })
      .catch(error => {
        console.error('Error al guardar los datos:', error);
        notifyerr();
        return ; //setDatosIng('error')
      });
}

async function clickspecial() {
  const clientee = await convertirespecial();
  if (isNaN(manejoHoras.apertura)) {
    toast.error('La fecha seleccionada no esta disponible.');
    return;
  }
  let hasErrors = false;
  let newErrors = {...errors};
  Object.keys(clientee).forEach((key) => {
    if (key === 'CorreoCliente' || key === 'Descripcion') {
      return
    }
      if (String(clientee[key]).trim() === '') {
          newErrors[key] = true;
          hasErrors = true;
      }
  });
  setErrors(newErrors);
  if (hasErrors) {
      toast.error('Por favor, completa todos los campos.');
      return;
  }
  const datcancha = (tipoca) => {
    if (tipoca === "5") {
      const resultipoca = arre5.find(datos => datos.id === asignado);
      return resultipoca;
    }
    else if (tipoca === "7"){
      const resultipoca = arre7.find(datos => datos.id === asignado);
      return resultipoca;
    }
    else if (tipoca === "11"){
      const resultipoca = arre11.find(datos => datos.id === asignado);
      return resultipoca;
    }
  }
  const canchasel = datcancha(clientee.Tipo);

  axios.post(`${process.env.REACT_APP_HTTPS}/api/reserva/special`, {clientee, canchasel})
    .then(response => {
        console.log('Datos guardados exitosamente:', response.data);
        notify();
        terminarboton();
        return;//setDatosIng('ingresados')
      })
      .catch(error => {
        console.error('Error al guardar los datos:', error);
        notifyerr();
        return ; //setDatosIng('error')
      });
}

const clickrechazar = (razon) =>{
  let newErrors = {...errors};
  let hasErrors = false;
  if (String(cliente.Descripcion).trim() === '') {
    newErrors['Descripcion'] = true;
    hasErrors = true;
  } 
  setErrors(newErrors);
  if (hasErrors) {
      toast.error('Por favor, completa todos los campos.');
      return; 
  }
  const rechazo = {...ResInfo, Descripcion: cliente.Descripcion, estado: razon}
  axios.post(`${process.env.REACT_APP_HTTPS}/api/reserva/rechazar`, {rechazo, otrainfo})
    .then(response => {
        console.log('Datos actualizado exitosamente:', response.data);
        notify();
        return;//setDatosIng('ingresados')
      })
      .catch(error => {
        console.error('Error al borrar los datos:', error);
        notifyerr();
        return ; //setDatosIng('error')
      });
  terminarboton();
}

function convertirdatos(){
  return new Promise(resolve =>{
  const formateado2 = formatHorasnd(horastring)
  const datosarreglados = {
    NombreCliente: cliente.NombreCliente,
    CorreoCliente: cliente.CorreoCliente,
    TelefonoCliente: cliente.TelefonoCliente,
    Cancha_asignada: asignado,
    Tipo: cliente.Tipo,
    Medio:'Manual',
    Estado:'Aprobada',
    Descripcion: cliente.Descripcion,
    Hora: formateado2,
    Fecha: datestring
  }
    resolve(datosarreglados);
  })
}

function convertirespecial(){
  return new Promise(resolve =>{
  const formateado2 = formatHorasnd(horastring);
  const formateado3 = formatHorasnd(horastringfin);
  const datosarreglados = {
    NombreCliente: cliente.NombreCliente,
    CorreoCliente: cliente.CorreoCliente,
    TelefonoCliente: cliente.TelefonoCliente,
    Cancha_asignada: asignado,
    Tipo: cliente.Tipo,
    Medio:'Manual',
    Estado:'Aprobada',
    Descripcion: cliente.Descripcion,
    HoraIni: formateado2,
    HoraFin: formateado3,
    Fecha: datestring
  }
    resolve(datosarreglados);
  })
}

function convertirdatoseditar(){
  return new Promise(resolve =>{
  const formateado2 = formatHorasnd(horastring)
  const datosarreglados = {...ResInfo,
    cancha_asignada: asignado,
    dia_asignado: datestring,
    hora_asignada: formateado2,
  };
  resolve (datosarreglados);
  })
}
const formatHorasnd = (hora) => {
  if (hora) {
    const HrForm = hora.toLocaleTimeString('es-GT', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false});
    return HrForm;
  }
  else  {
    return null;
  }
}

  const handleRadioChange = (event) => {
    setRadiobuttonnew(event.target.value);
    setCliente({...cliente, ['Tipo']: event.target.value})
    setasignado('')
  };

    return(
        <>
        {uso === 'asignar' ? (<><div className='contasig'>
        <div className="asignar">
            <button className='cerrarasignar' onClick={()=> cerrarpestana()}><img src={regr} id='regresar'/> </button>
            <div className="setcancha">
                <h3>Asinga una cancha para {ResInfo.Nombre_cliente} de futbol {ResInfo.tipo_cancha}</h3>
                <p>La cancha sera asignada para el dia <b>{dia}</b>, a las <b>{hora}:00.</b></p>
                {ResInfo.tipo_cancha === 5 ? (<div className='divselect'>
                    <select onChange={Registrar} value={asignado} defaultValue={''}>
                    <option disabled></option>
                    {arre5.map((cancha,i)=>(
                        <option key={i} value={cancha.id}>{cancha.nombre}</option>
                    ))}
                </select></div>
                ): ResInfo.tipo_cancha === 7 ? (<div className='divselect'>
                    <select onChange={Registrar} value={asignado} defaultValue={''}>
                    <option disabled></option>
                    {arre7.map((cancha,i)=>(
                        <option key={i} value={cancha.id}>{cancha.nombre}</option>
                    ))}
                </select></div>): ResInfo.tipo_cancha === 11 ?(
                    <div className='divselect'>
                    <select onChange={Registrar} value={asignado} defaultValue={''}>
                    <option disabled></option>
                    {arre11.map((cancha,i)=>(
                        <option key={i} value={cancha.id}>{cancha.nombre}</option>
                    ))}
                </select></div>
                ):(<></>)}
                <div><p>Correo: <b>{ResInfo.correo}</b></p>
                <p>Contacto: <b>{ResInfo.contacto}</b></p></div>
                <div className='divbtnasignar'><button className='btnasignar' onClick={clickasignar}>Asignar</button>
                </div><button className='btnasignarfecha' onClick={clickcambfecha}>Cambiar fecha</button>
                {/**<p>{asignado}, {id}</p>*/}
            </div>
        </div></div></>
        ): uso === 'editar' ?(<><div className='contasig'>
            <div className="asignar"><button className='cerrarasignar' onClick={()=> cerrarpestana()}><img src={regr} id='regresar'/> </button>
            <div className="setcancha">
                <h3>Cambia la cancha para {ResInfo.Nombre_cliente}</h3>
                <p>Cambia los datos que necesites</p>
                {ResInfo.tipo_cancha === 5 ? (<div className='divselect'>
                    <select onChange={Registrar} value={asignado}>
                    <option disabled></option>
                    {arre5.map((cancha,i)=>(
                        <option key={i} value={cancha.id}>{cancha.nombre}</option>
                    ))}
                </select></div>
                ): ResInfo.tipo_cancha === 7 ? (<div className='inpdivselect'>
                    <select onChange={Registrar} value={asignado}>
                    <option disabled></option>
                    {arre7.map((cancha,i)=>(
                        <option key={i} value={cancha.id}>{cancha.nombre}</option>
                    ))}
                </select></div>): ResInfo.tipo_cancha === 11 ?(<div className='inpdivselect'>
                    <select onChange={Registrar} value={asignado}>
                    <option disabled></option>
                    {arre11.map((cancha,i)=>(
                        <option key={i} value={cancha.id}>{cancha.nombre}</option>
                    ))}
                </select></div>): (<></>)}
                <DatePicker selected={datestring} dateFormat="EEEE, dd 'de' MMMM 'de' yyyy" onChange={(date)=>setDatestring(date)} locale="es"
                      minDate={new Date()}
                      className='inpdate'
                      maxDate={siete}
                      customInput={<input inputMode="none"></input>}
                      preventOpenOnFocus
                      />
                      <br/>
                      
                <DatePicker 
                    selected={horastring}
                    onChange={(date)=>setHoraString(date)}
                    disabled = {isNaN(manejoHoras.apertura) ? true : false}
                    showTimeSelect
                    className='inptime'
                    showTimeSelectOnly
                    timeIntervals={60}
                    minTime={new Date().setHours(parseInt(manejoHoras.apertura - 1), 0)}
                    maxTime={new Date().setHours(parseInt(manejoHoras.cierre - 1), 0)}
                    timeCaption='Hora'
                    dateFormat="h:mm aa"
                    customInput={<input inputMode="none"></input>}
                    preventOpenOnFocus/>
                <div className='divbtnasignar'><button className='btnasignar'  onClick={clickeditar}>Editar</button></div>
                 {/**<p>{asignado}, {id} , {diaISO}, id cancha: {id_cancha}</p>
                <p>Dia  {String(datestring.toLocaleDateString('es-GT', {
        weekday: 'long'
        })).split(' ')[0]}, Apertura: {manejoHoras.apertura} y Cierre: {manejoHoras.cierre} , Hora: {hora} </p> */}
            </div>
            </div></div></>
        ):uso === 'newreserva' ? (<><div className='contasig'>
          <div className="newreservad">
              <button className='cerrarasignar' onClick={()=> cerrarpestana()}><img src={regr} id='regresar'/> </button>
              <div className="setcancha">
              <div className='contenee'>
                <div className='colu1'>
                    <p>Nombre: </p><input type='text' name='NombreCliente' onChange={RegistrarInput}
                            style={{ borderColor: errors.NombreCliente ? 'red' : 'initial' }} placeholder='Nombre'/>
                    <p>Correo: </p><input type='text' name='CorreoCliente' onChange={RegistrarInput2}
                            style={{ borderColor: errors.CorreoCliente ? 'red' : 'initial' }} placeholder='Correo electrónico'/>
                    <p>Teléfono: </p><input type='number' maxLength={8} name='TelefonoCliente' onChange={RegistrarInput}
                            style={{ borderColor: errors.TelefonoCliente ? 'red' : 'initial' }} placeholder='Número de teléfono'/>
                    <p>Tipo de cancha: </p><form>
                        {arre5.length > 0 ? (<><input type="radio" id="F5" value="5" name='Tipo' className='radio' onChange={handleRadioChange} />
                        <label htmlFor="F5">Futbol 5</label><br/></>):(<></>)}
                        {arre7.length > 0 ? (<><input type="radio" id="F7" value="7" name='Tipo' className='radio' onChange={handleRadioChange} />
                          <label htmlFor="F7">Futbol 7</label><br/></>):(<></>)}
                        {arre11.length > 0 ? (<><input type="radio" id="F11" value="11" name='Tipo' className='radio' onChange={handleRadioChange} />
                          <label htmlFor="F11">Futbol 11</label></>):(<></>)}
                        <br/>
                      </form>
                    </div><div className='colu2'>
                    <p>Fecha: </p> <label><DatePicker selected={datestring} dateFormat="EEEE, dd 'de' MMMM 'de' yyyy" onChange={(date)=>setDatestring(date)} locale="es"
                      minDate={new Date()}
                      maxDate={siete}
                      className='inpdate'
                      customInput={<input inputMode="none"></input>}
                      preventOpenOnFocus
                      placeholderText='Seleccione la fecha'
                      /></label>
                    <p>Hora: </p> <label><DatePicker 
                    selected={horastring}
                    onChange={(date)=>setHoraString(date)}
                    showTimeSelect
                    showTimeSelectOnly
                    disabled = {isNaN(manejoHoras.apertura) ? true : false}
                    timeIntervals={60}
                    className='inptime'
                    minTime={new Date().setHours(parseInt(manejoHoras.apertura - 1), 0)}
                    maxTime={new Date().setHours(parseInt(manejoHoras.cierre - 1), 0)}
                    timeCaption='Hora'
                    dateFormat="h:mm aa"
                    customInput={<input inputMode="none"></input>}
                    preventOpenOnFocus
                    placeholderText='Seleccione la hora'/></label>
                    <p>Comentario: </p><input type='text' name='Descripcion' onChange={RegistrarInput2}
                            style={{ borderColor: errors.Descripcion ? 'red' : 'initial' }} placeholder='Ingrese su comentario'/>
                    <p>Cancha asignada:</p>
                    <div className='divselect'>
                      {radiobuttonnew === '5' ? (<>
                        <select onChange={Registrar} value={asignado} defaultValue={''}>
                          <option disabled></option>
                          {arre5.map((cancha,i)=>(
                              <option key={i} value={cancha.id}>{cancha.nombre}</option>
                          ))}
                      </select>
                      </>): radiobuttonnew === '7' ?(<>
                        <select onChange={Registrar} value={asignado} defaultValue={''}>
                          <option disabled></option>
                          {arre7.map((cancha,i)=>(
                              <option key={i} value={cancha.id}>{cancha.nombre}</option>
                          ))}
                      </select>
                      </>): radiobuttonnew === '11' ?(<>
                        <select onChange={Registrar} value={asignado} defaultValue={''}>
                          <option disabled></option>
                          {arre11.map((cancha,i)=>(
                              <option key={i} value={cancha.id}>{cancha.nombre}</option>
                          ))}
                      </select>
                      </>):(<></>)}
                    </div></div></div>
                  <div className='divbtnasignar'><button className='btnasignar' onClick={clcikenviar}>Ingresar</button></div><div>
                  <button className='btnasignarfecha' onClick={clickespecial}>Especial</button>
                  <div></div>
                  </div>
              </div>
          </div></div></>
          ):uso === 'borrar' ? (<><div className='contasig'>
            <div className="asignar">
                <button className='cerrarasignar' onClick={()=> cerrarpestana()}><img src={regr} id='regresar'/> </button>
                <div className="setcancha">
                    <h3>Cancela de reserva</h3>
                    <p>La reserva solicitada por <b>{ResInfo.Nombre_cliente}</b> para el dia <b>{dia}</b>, a las <b>{hora}:00.</b> sera cancelada. Por favor coloca la razon de la cancelacion.</p>
                    <p>Razon: </p><input type='text' className='iptrechazo' name='Descripcion' onChange={RegistrarInput}
                              style={{ borderColor: errors.Descripcion ? 'red' : 'initial' }}/>
                    <div className='divbtnasignar'><button className='btnasignar' onClick={() => clickrechazar('Cancelada')}>Cancelar</button></div>
                    {/**<p>{asignado}, {id}</p>*/}
                </div>
            </div></div></>
        ):uso === 'rechazar' ? (<><div className='contasig'>
          <div className="asignar">
              <button className='cerrarasignar' onClick={()=> cerrarpestana()}><img src={regr} id='regresar'/> </button>
              <div className="setcancha">
                  <h3>Rechazo de reserva</h3>
                  <p>La reserva solicitada por <b>{ResInfo.nombre}</b> para el dia <b>{dia}</b>, a las <b>{hora}:00.</b> sera rechazada. Por favor coloca la razon del rechazo para el cliente.</p>
                  <p>Razon del rechazo: </p><input type='text' className='iptrechazo' name='Descripcion' onChange={RegistrarInput}
                            style={{ borderColor: errors.Descripcion ? 'red' : 'initial' }}/>
                  <div className='divbtnasignar'><button className='btnasignar' onClick={() => clickrechazar('Rechazada')}>Rechazar</button></div>
                  {/**<p>{asignado}, {id}</p>*/}
              </div>
          </div></div></>
          ):uso === 'especial' ? (<>
          <div className='contasig'>
          <div className="newreservad">
              <button className='cerrarasignar' onClick={()=> cerrarpestana()}><img src={regr} id='regresar'/> </button>
              <div className="setcancha">
              <div className='contenee'><h2 style={{gridColumn: "span 2"}}>Reserva Especial</h2>
                <div className='colu1'>
                    <p>Nombre: </p><input type='text' name='NombreCliente' onChange={RegistrarInput}
                            style={{ borderColor: errors.NombreCliente ? 'red' : 'initial' }} placeholder='Nombre'/>
                    <p>Correo: </p><input type='text' name='CorreoCliente' onChange={RegistrarInput2}
                            style={{ borderColor: errors.CorreoCliente ? 'red' : 'initial' }} placeholder='Correo electrónico'/>
                    <p>Teléfono: </p><input type='number' maxLength={8} name='TelefonoCliente' onChange={RegistrarInput}
                            style={{ borderColor: errors.TelefonoCliente ? 'red' : 'initial' }} placeholder='Número de teléfono'/>
                    <p>Tipo de cancha: </p><form>
                        {arre5.length > 0 ? (<><input type="radio" id="F5" value="5" name='Tipo' className='radio' onChange={handleRadioChange} />
                        <label htmlFor="F5">Futbol 5</label><br/></>):(<></>)}
                        {arre7.length > 0 ? (<><input type="radio" id="F7" value="7" name='Tipo' className='radio' onChange={handleRadioChange} />
                          <label htmlFor="F7">Futbol 7</label><br/></>):(<></>)}
                        {arre11.length > 0 ? (<><input type="radio" id="F11" value="11" name='Tipo' className='radio' onChange={handleRadioChange} />
                          <label htmlFor="F11">Futbol 11</label></>):(<></>)}
                        <br/>
                      </form>
                    </div><div className='colu2'>
                    <p>Fecha: </p> <label><DatePicker selected={datestring} dateFormat="EEEE, dd 'de' MMMM 'de' yyyy" onChange={(date)=>setDatestring(date)} locale="es"
                      minDate={new Date()}
                      maxDate={siete}
                      className='inpdate'
                      customInput={<input inputMode="none"></input>}
                      preventOpenOnFocus
                      placeholderText='Seleccione la fecha'
                      /></label>
                      <div className='sp_horas'>
                        <div className='sp_1'>
                          <p>Hora de inicio: </p>
                          <label><DatePicker 
                            selected={horastring}
                            onChange={(date)=>setHoraString(date)}
                            showTimeSelect
                            showTimeSelectOnly
                            disabled = {isNaN(manejoHoras.apertura) ? true : false}
                            timeIntervals={60}
                            className='inptime'
                            minTime={new Date().setHours(parseInt(manejoHoras.apertura - 1), 0)}
                            maxTime={new Date().setHours(parseInt(manejoHoras.cierre - 1), 0)}
                            timeCaption='Hora'
                            dateFormat="h:mm aa"
                            customInput={<input inputMode="none"></input>}
                            preventOpenOnFocus
                            placeholderText='Seleccione la hora'/></label>
                          </div>
                        <div className='sp_2'>
                          <p>Hora de fin: </p>
                          <label><DatePicker 
                            selected={horastringfin}
                            onChange={(date)=>setHoraStringfin(date)}
                            showTimeSelect
                            showTimeSelectOnly
                            disabled = {isNaN(manejoHoras.apertura) ? true : false}
                            timeIntervals={60}
                            className='inptime'
                            minTime={new Date().setHours(parseInt(manejoHoras.apertura - 1), 0)}
                            maxTime={new Date().setHours(parseInt(manejoHoras.cierre - 1), 0)}
                            timeCaption='Hora'
                            dateFormat="h:mm aa"
                            customInput={<input inputMode="none"></input>}
                            preventOpenOnFocus
                            placeholderText='Seleccione la hora'/></label>
                        </div>
                      </div> 
                    <p>Comentario: </p><input type='text' name='Descripcion' onChange={RegistrarInput2}
                            style={{ borderColor: errors.Descripcion ? 'red' : 'initial' }} placeholder='Ingrese su comentario'/>
                    <p>Cancha asignada:</p>
                    <div className='divselect'>
                      {radiobuttonnew === '5' ? (<>
                        <select onChange={Registrar} value={asignado} defaultValue={''}>
                          <option disabled></option>
                          {arre5.map((cancha,i)=>(
                              <option key={i} value={cancha.id}>{cancha.nombre}</option>
                          ))}
                      </select>
                      </>): radiobuttonnew === '7' ?(<>
                        <select onChange={Registrar} value={asignado} defaultValue={''}>
                          <option disabled></option>
                          {arre7.map((cancha,i)=>(
                              <option key={i} value={cancha.id}>{cancha.nombre}</option>
                          ))}
                      </select>
                      </>): radiobuttonnew === '11' ?(<>
                        <select onChange={Registrar} value={asignado} defaultValue={''}>
                          <option disabled></option>
                          {arre11.map((cancha,i)=>(
                              <option key={i} value={cancha.id}>{cancha.nombre}</option>
                          ))}
                      </select>
                      </>):(<></>)}
                    </div></div></div>
                  <div className='divbtnasignar'><button className='btnasignar' onClick={clickspecial}>Ingresar</button></div><div>
                  <div></div>
                  </div>
              </div>
          </div></div>
          </>
          ):(<><p></p></>)}
          <Toaster />
    </>
    );
}
export default Asignar;